import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface SwapDataState {
  data: any | null; // Define your data type as needed
}
const initialState: SwapDataState = {
  data: null,
};
const swapDataSlice = createSlice({
  name: 'swapData',
  initialState,
  reducers: {
    setSwapData: (state, action: PayloadAction<any>) => {
      state.data = action.payload; // Save the data
    },
    removeSwapData: (state) => {
      state.data = null; // Remove the data
    },
  },
});
export const { setSwapData, removeSwapData } = swapDataSlice.actions;
export default swapDataSlice.reducer;
export const selectItem = (state: { swapData: SwapDataState }) => state.swapData.data;






